export default __webpack_public_path__ + "f0b2acd00a3741540bc985bbda792c2a.jpeg";